import { Navbar } from "./Navbar";
import { Footer } from "@mmfestival/shared-components";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

export const Layout = () => {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();
  // Admin-chrome routes: the full-screen admin shell (own sidebar) renders
  // these, so the public navbar/footer must stay hidden. /smm/rpc is the
  // single-event racepack desk and lives outside /admin.
  const isAdminRoute =
    path.startsWith("/admin") || path.startsWith("/smm/rpc");

  useEffect(() => {
    document.body.classList.toggle("admin-route", isAdminRoute);
    return () => document.body.classList.remove("admin-route");
  }, [isAdminRoute]);

  const shouldHideFooter = [
    "/login",
    "/lupapassword",
    "/xtrifeinnie",
    "/pesanan-detail",
    "/verify",
    "/register",
    isAdminRoute,
    path.startsWith("/detailanggota/"),
  ].some((route) => (typeof route === "string" ? path === route : route));

  const shouldHideNavbar = isAdminRoute;

  return (
    <div className="flex flex-col min-h-screen">
      {!shouldHideNavbar && (
        <div className="z-50 w-full flex justify-center">
          <Navbar />
        </div>
      )}

      <main className="flex-grow">
        <Outlet />
      </main>

      {!shouldHideFooter && (
        <div className="w-full">
          <Footer />
        </div>
      )}
    </div>
  );
};
